import _extends from "@babel/runtime/helpers/extends";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { components } from "react-select";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const ValueContainer = props => {
  return jsx(components.ValueContainer, _extends({}, props, {
    css: css`
                // Need to ensure that we show as much of the SingleValue component as possible.
                align-self: stretch;
                padding-left: 0;
            `
  }), props.children);
};
//# sourceMappingURL=ValueContainer.js.map